export const webApi = {
  domain: 'https://api.keeel.in',
  // domain: 'http://localhost:8100',

  endPoint: {
    sendNotificationInApp: '/api/v1/notification/sendNotificationInApp',
    sendMailToDonar: '/api/v1/notification/sendMailToDonar', //http://localhost:8100/api/v1/notification/sendMailToDonar
  },
};
